import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/substitution-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
//import Form from '../../components/SubstitutionForm';
import { ISubstitution } from 'src/types/substitution';

export interface StateProps {
    substitution: ISubstitution | null;
    inProgress: boolean;
    files: any;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getFiles: (id: string | number) => void;
    addFiles: (id: string | number, files: any) => void;
    removeFile: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const SubstitutionEditScreen: FC<Props> = (props: Props) => {
    const {
        substitution,
        inProgress,
        match: {
            params: { id },
        },
        getFiles,

        getData,
    } = props;

    useEffect(() => {
        if (!substitution || substitution.id !== id) {
            getData(id);
            getFiles(id);
        }
        // eslint-disable-next-line
    }, [getFiles, getData, id]);

    if (!substitution || inProgress) {
        return <Loader />;
    }

    return (
        <RoleLayout>
            <div>
                <h2>SUBSTITUTIONS {`>`} EDIT SUBSTITUTION</h2>
            </div>
            <div className={classNames(styles.editWrap)}></div>
        </RoleLayout>
    );
};
export default SubstitutionEditScreen;
